/* House of Ayurveda — HOA-18 symptom picker (native section: sections/hoa-symptom-picker.liquid).
   All cards are rendered by Liquid; this only switches the visible one, scrolls
   the CTA back to the buy box, and keeps the analytics events the A/B test fired
   (dataLayer "hoa18_<name>", DOM "hoa:hoa18:<name>", optional window.__hoaTrack). */
(function () {
  "use strict";
  if (window.__hoaSymptomPicker) return;
  window.__hoaSymptomPicker = true;

  function fire(name, detail) {
    var payload = detail || {};
    payload.test = "HOA-18";
    payload.source = "native";
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "hoa18_" + name, hoa: payload });
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent("hoa:hoa18:" + name, { detail: payload }));
    } catch (e) {}
    try {
      if (typeof window.__hoaTrack === "function") window.__hoaTrack("hoa18_" + name, payload);
    } catch (e) {}
  }

  function labelOf(chip) {
    return (chip.textContent || "").trim();
  }

  function select(root, chip) {
    var wasOn = chip.getAttribute("aria-pressed") === "true";
    var key = wasOn ? null : chip.getAttribute("data-hoa-sp-key");

    [].forEach.call(root.querySelectorAll(".hoa-sp__chip"), function (c) {
      c.setAttribute("aria-pressed", c === chip && !wasOn ? "true" : "false");
    });
    [].forEach.call(root.querySelectorAll("[data-hoa-sp-card]"), function (card) {
      card.hidden = card.getAttribute("data-hoa-sp-card") !== key;
    });
    var reveal = root.querySelector(".hoa-sp__reveal");
    if (reveal) reveal.classList.toggle("is-open", !!key);

    fire("symptom", { key: chip.getAttribute("data-hoa-sp-track") || labelOf(chip), on: !wasOn });
  }

  function scrollToBuyBox() {
    var target =
      document.querySelector(".main-product__info-container .bundle-offer-section") ||
      document.querySelector(".main-product__info-container .main-product-atc") ||
      document.querySelector(".main-product__info-container button[name='add']") ||
      document.querySelector(".main-product__info-container");
    if (!target) return;
    try {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    } catch (e) {
      target.scrollIntoView();
    }
  }

  // One delegated listener: survives theme-editor section re-renders.
  document.addEventListener("click", function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    var chip = t.closest(".hoa-sp__chip");
    if (chip) {
      var root = chip.closest("[data-hoa-sp]");
      if (root) select(root, chip);
      return;
    }

    var cta = t.closest("[data-hoa-sp-cta]");
    if (cta) {
      fire("cta_click", { label: labelOf(cta) });
      scrollToBuyBox();
    }
  });

  function init() {
    var roots = document.querySelectorAll("[data-hoa-sp]");
    if (!roots.length) return;
    fire("render", {});
    if (typeof IntersectionObserver !== "function") return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            io.disconnect();
            fire("view", {});
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(roots[0]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
